import { render, staticRenderFns } from "./procurementDetail.vue?vue&type=template&id=5a87230b&scoped=true"
import script from "./procurementDetail.vue?vue&type=script&lang=js"
export * from "./procurementDetail.vue?vue&type=script&lang=js"
import style0 from "./procurementDetail.vue?vue&type=style&index=0&id=5a87230b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a87230b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a87230b')) {
      api.createRecord('5a87230b', component.options)
    } else {
      api.reload('5a87230b', component.options)
    }
    module.hot.accept("./procurementDetail.vue?vue&type=template&id=5a87230b&scoped=true", function () {
      api.rerender('5a87230b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ordercenter/procurementDetail.vue"
export default component.exports